module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "textStyle4"
  }, [_vm._v("The Characters in the Tale")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Chief Detective-Inspector Roderick Alleyn,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("C.I.D.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Miss Van Maes,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("the success of the ship.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Agatha Troy,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("R.A., of Tatter’s End House, Bossicote, Bucks. Painter.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Katti Bostock,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("well-known painter of plumbers and black musicians.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Nigel Bathgate,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("journalist.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Lady Alleyn, of Danes Lodge, Bossicote, Bucks;")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("mother of Chief Detective-Inspector Alleyn.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Cedric Malmsley,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("a student with a beard.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Garcia,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("a sculptor.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Sonia Gluck,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("a model.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Francis Ormerin,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("a student from Paris.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Phillida Lee,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("a student from the Slade.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Watt Hatchett,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("a student from Australia.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("The Hon. Basil Pilgrim,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("a student from the nobility.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Valmai Seacliff,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("a student with sex-appeal.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Superintendent Blackman,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("of the Buckingham Constabulary Force.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Detective-Inspector Fox,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("C.I.D.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Detective-Sergeant Bailey,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("C.I.D., a fingerprint expert.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Detective-Sergeant Thompson,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("C.I.D., a photographic expert.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Dr. Ampthill,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("police surgeon at Bossicote, Bucks.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("P.C. Sligo,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("of Bossicote Police force.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("A Charlady")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Bobbie O’Dawne,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("a lady of the Ensemble.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("An Estate Agent")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Ted McCully,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("foreman at a car depot.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Dr. Curtis,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("police surgeon, C.I.D.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Captain Pascoe, of Boxover.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("His Servant")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57a73100","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/FrontMatter01.vue
// module id = 63
// module chunks = 0